import(/* webpackMode: "eager", webpackExports: ["ReviewsPageContent"] */ "/vercel/path0/app/earn/ReviewsPageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageLayout"] */ "/vercel/path0/app/layouts/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EarnHeroBanner"] */ "/vercel/path0/components/Earn/EarnHeroBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FundingSidebar"] */ "/vercel/path0/components/Funding/FundingSidebar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
